import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProjectsCampaignFileMultiAddComponent } from '../../dialogs/projects-campaign-file-multiadd/projects-campaign-file-multiadd.component';
import { MainService } from 'src/app/services/main.service';
import { ProjectsCampaignCommentsAddComponent } from '../projects-campaign-comments-add/projects-campaign-comments-add.component';
import { ProjectModel, ProjectPhase } from 'src/app/models/project.model';
import { ProjectsService } from 'src/app/services/projects.service';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-projects-art-multiupload',
  templateUrl: './projects-art-multiupload.component.html',
  styleUrls: ['./projects-art-multiupload.component.scss']
})
export class ProjectsArtMultiUploadComponent implements OnInit {
  curr_diagram!: any;
  phase!: ProjectPhase;
  project: ProjectModel = new ProjectModel();
  archivos: any = [];
  next_id: number = 0;
  projectConf : any;
  arr_order : any = [];
  next_vobo : any;
  usersUpload : any = [];
  datafases : any = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    public dialogRef: MatDialogRef<ProjectsArtMultiUploadComponent>,
    private projectsS: ProjectsService,
    private matDialog: MatDialog,
    private main : MainService,
    private users : UsersService) { 
      this.project = data.project;
      this.projectConf = data.projectConf;
      this.datafases = data.fases; 
      console.log("data sent", this.data);
    }

  ngOnInit() {
    console.log("Next Init");
 //   const next = this.curr_diagram.config_vobos.find((e:any)=>e.vobos.some((v:any)=>(v.status?v.status:0)==0));
 //   if(next){
 //     this.next_id = next.id;
 //   }
    //this.getArchivosByPhase();
    //this.calculateNextVobo();
  

        this.usersUpload  = this.data.art_users.map((u:any) => u.id);
    
   

    console.log("users to upload", this.usersUpload);
  } 

    selectedFase : any;
    selected = false;

  changeFase(value : any){
    
      this.selected = true;
      this.selectedFase = value;

     const next = this.data.fases.find((x:any)=>x.id === value).vobos.find((v:any)=>(v.status?v.status:0)==0);
      if(next){
        this.next_id = next.id;
      }

  }

  currentAreaVobo : number = 0;

  calculateNextVobo(){
    let indexActual = this.arr_order
    .map((item:any, index:number) => ({ item, index }))
    .filter(({ item } : any) => item.id_fase === this.phase.id)
    .map(({ index } : any) => index);
    console.log("index actual", indexActual, this.arr_order.length)
    if((indexActual[0] + 1) < this.arr_order.length){
      let next_ax = this.arr_order[indexActual[0] + 1];
      let usr_aux : any[] = [];
      let arts_users : any = [];
      switch (next_ax.tipo) {
        case "art":
          try{
            usr_aux = this.usersUpload 
          }catch(ex){}
            this.next_vobo = {tipo : "art", users : usr_aux, arts_users: usr_aux };
          break;
        case "vobo":
          try{
            arts_users = this.usersUpload 
            this.currentAreaVobo =  next_ax.id_vobo;
            usr_aux = this.curr_diagram.config_vobos.filter((f:any)=> f.id == next_ax.id_fase)[0].vobos.filter((v:any)=> v.id == next_ax.id_vobo)[0].users;
          }catch(ex){}
            this.next_vobo = {tipo : "vobo", users : usr_aux, arts_users : arts_users};
          break;
        case "prov":
          try{
            this.currentAreaVobo =  next_ax.id_vobo;
            usr_aux = this.curr_diagram.config_vobos.filter((f:any)=> f.id == next_ax.id_fase)[0].vobos.filter((v:any)=> v.id == next_ax.id_vobo)[0].users;
          }catch(ex){}
            this.next_vobo = {tipo : "prov", users : usr_aux, arts_users : arts_users};
          break;
        default:
          break;
      }
      console.log("next vobo", this.next_vobo);
    }
  }

  openDialogUploadCampaignFile() {
    this.matDialog.open(ProjectsCampaignFileMultiAddComponent, {
      panelClass: ['dialogs-main'],
      data: {
        phase_id : this.selectedFase,
        phase : this.datafases.find((f:any)=> f.id == this.selectedFase).name,
        project : this.project,
        folder : this.project.folder,
      }
    }).afterClosed().subscribe(
      resp => {
        if(resp?.reload) {
          this.dialogRef.close({ reload: true });
        }
      }
    );
  }


  openDialogCommentNoAuth(phase_id : number, rol_id : number) {
    this.matDialog.open(ProjectsCampaignCommentsAddComponent, {
      panelClass: ['dialogs-sm'],
      data: {
          phase_id : phase_id,
          rol_id : rol_id,
          camp_id : 1,
          nombre : "DANGLERS VERSION 1 - FASE 1"
        }
    }).afterClosed().subscribe(
      resp => {
      }
    );
  }


}
